/* eslint-disable no-restricted-imports */
/* eslint-disable react/forbid-elements */
import { Paragraph, XStack, YStack } from '@bounty/creators-design-system'
import FastCompany from '../../../assets/fastcompany.png'
import Techcrunch from '../../../assets/techcrunch.png'
import Yahoo from '../../../assets/yahoo.png'
import BusinessInsider from '../../../assets/businessinsider.png'
import Link from 'next/link'

export const FeaturedIn = () => {
  return (
    <YStack>
      <Paragraph color="rgb(56, 56, 57)" textAlign="center" mb="$5">
        featured in
      </Paragraph>
      <XStack flexWrap="wrap" justifyContent="center">
        <Link href="http://fastcompany.com/90756003/jones-road-paying-customers-tiktok-bounty-marketing">
          <img
            loading="lazy"
            alt="Fast company logo"
            src={FastCompany}
            style={{
              height: '22px',
              objectFit: 'contain',
              marginBottom: '1rem',
              paddingLeft: '1rem',
              paddingRight: '1rem',
            }}
          />
        </Link>
        <Link
          href={
            'http://techcrunch.com/2022/08/02/bounty-raises-4-7m-to-help-everyday-tiktokers-make-money-from-reviews/'
          }
        >
          <img
            loading="lazy"
            alt="tech crunch logo"
            src={Techcrunch}
            style={{
              height: '21px',
              objectFit: 'contain',
              marginBottom: '1rem',
              paddingLeft: '1rem',
              paddingRight: '1rem',
            }}
          />
        </Link>
        <Link href="https://www.yahoo.com/now/bounty-app-announces-closing-5-151100308.html">
          <img
            loading="lazy"
            alt="Yahoo logo"
            src={Yahoo}
            style={{
              height: '34px',
              objectFit: 'contain',
              marginBottom: '1rem',
              paddingLeft: '1rem',
              paddingRight: '1rem',
            }}
          />
        </Link>
        <Link href="https://www.businessinsider.com/top-14-creator-economy-influencer-startups-according-to-vcs-2022-9">
          <img
            loading="lazy"
            alt="Business insider logo"
            src={BusinessInsider}
            style={{
              height: '36px',
              objectFit: 'contain',
              marginBottom: '1rem',
              paddingLeft: '1rem',
              paddingRight: '1rem',
            }}
          />
        </Link>
      </XStack>
    </YStack>
  )
}
